// extracted by mini-css-extract-plugin
export default {"formContainer":"AutomationDialog_formContainer__0q5YU","templateList":"AutomationDialog_templateList__N+g1q"};